import React from 'react';
import { MoonIcon, BrainIcon, EyeOffIcon, CompassIcon } from 'lucide-react';
export function ProblemSection() {
  return <section id="problema" className="py-20 bg-white" data-id="element-300">
      <div className="container mx-auto px-4" data-id="element-301">
        <div className="max-w-4xl mx-auto" data-id="element-302">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-purple-800" data-id="element-303">
            El Problema Oculto Que Nadie Te Dice
          </h2>
          <p className="text-lg text-center text-gray-700 mb-12" data-id="element-304">
            Si hoy vives con:
          </p>
          <div className="grid md:grid-cols-2 gap-8" data-id="element-305">
            <div className="bg-purple-50 p-6 rounded-xl shadow-sm flex" data-id="element-306">
              <div className="mr-4 text-purple-600" data-id="element-307">
                <MoonIcon size={24} data-id="element-308" />
              </div>
              <div data-id="element-309">
                <h3 className="font-semibold text-lg mb-2 text-purple-800" data-id="element-310">
                  Noches sin calma
                </h3>
                <p className="text-gray-600" data-id="element-311">
                  Mente encendida que no descansa.
                </p>
              </div>
            </div>
            <div className="bg-purple-50 p-6 rounded-xl shadow-sm flex" data-id="element-312">
              <div className="mr-4 text-purple-600" data-id="element-313">
                <BrainIcon size={24} data-id="element-314" />
              </div>
              <div data-id="element-315">
                <h3 className="font-semibold text-lg mb-2 text-purple-800" data-id="element-316">
                  Ansiedad silenciosa
                </h3>
                <p className="text-gray-600" data-id="element-317">
                  Que desgasta tu energía día a día.
                </p>
              </div>
            </div>
            <div className="bg-purple-50 p-6 rounded-xl shadow-sm flex" data-id="element-318">
              <div className="mr-4 text-purple-600" data-id="element-319">
                <EyeOffIcon size={24} data-id="element-320" />
              </div>
              <div data-id="element-321">
                <h3 className="font-semibold text-lg mb-2 text-purple-800" data-id="element-322">
                  Vivir en automático
                </h3>
                <p className="text-gray-600" data-id="element-323">Sin claridad ni propósito real.</p>
              </div>
            </div>
            <div className="bg-purple-50 p-6 rounded-xl shadow-sm flex" data-id="element-324">
              <div className="mr-4 text-purple-600" data-id="element-325">
                <CompassIcon size={24} data-id="element-326" />
              </div>
              <div data-id="element-327">
                <h3 className="font-semibold text-lg mb-2 text-purple-800" data-id="element-328">
                  Buscar respuestas afuera
                </h3>
                <p className="text-gray-600" data-id="element-329">Y nunca encontrarlas...</p>
              </div>
            </div>
          </div>
          <div className="mt-12 bg-purple-100 p-8 rounded-2xl" data-id="element-330">
            <p className="text-lg text-gray-700" data-id="element-331">
              Es porque la verdadera causa de tu malestar no está en tu entorno,
              ni en tu trabajo, ni en tu familia. El problema es que llevas
              demasiado tiempo buscando afuera lo que solo puede encontrarse
              adentro.
            </p>
            <p className="mt-4 text-lg font-medium text-purple-800" data-id="element-332">
              El cielo, la paz, la claridad… siempre estuvieron dentro de ti.
              Solo olvidaste cómo acceder a ellos.
            </p>
          </div>
        </div>
      </div>
    </section>;
}